<template>
  <div class="news-item" @click="newsDetail(value.id)">
    <img class="news-cover" :src="value.picUrl">
    <div class="news-info">
      <div class="news-title ellipsis--l2" :title="value.title">{{ value.title }}</div>
      <div class="news-content ellipsis--l4">{{ value.text }}</div>
      <div class="news-other">
        <div class="news-time">{{ value.createTime }}</div>
        <div class="news-like">{{ value.collectionCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {}
  },

  methods: {
    /*
     * 跳转资讯详情
    */
    newsDetail(id) {
      this.$router.push({
        name: 'newsDetail',
        query: {
          id
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.news-item {
  display: flex;
  padding: 20px 0;
  border-bottom: 1px solid #f5f5f5;
  &:last-child {
    border: 0;
  }
  .news-cover {
    flex-shrink: 0;
    width: 377px;
    height: 226px;
    margin: 0 25px 0 0;
    cursor: pointer;
  }
  .news-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .news-title {
      font-size: 20px;
      line-height: 30px;
      font-weight: bold;
      cursor: pointer;
    }
    .news-content {
      color: #666;
      line-height: 22px;
      cursor: pointer;
    }
    .news-other {
      display: flex;
      align-items: center;
      color: #999;
      line-height: 15px;
      .news-time,
      .news-like {
        background-repeat: no-repeat;
        background-position: center left;
        padding: 0 0 0 21px;
      }
      .news-time {
        background-image: url("~@/assets/images/icon-clock-blue.png");
      }
      .news-like {
        background-image: url("~@/assets/images/icon-like-red.png");
        margin: 0 0 0 44px;
      }
    }
  }
}
</style>
